import bramidanPrivacyNotice from 'assets/privacy-notice/bramidan_privacy_notice_V1.pdf';
import React from 'react';

export const PrivacyNoticePdf = () => {
	return (
		<object data={bramidanPrivacyNotice} type="application/pdf" style={{ width: '100vw', height: '100vh' }}>
			<p>
				Unable to display PDF file. <a href={bramidanPrivacyNotice}>Download</a> instead.
			</p>
		</object>
	);
};
